import { PlayerProfileContext } from '@library/components/player/PlayerProfile';
import { useContext } from 'react';

export interface PlayerSecondaryHeaderProps {
  className?: string;
}

export const PlayerSecondaryHeader = ({
  className = undefined
}: PlayerSecondaryHeaderProps) => {
  const { secondaryHeader } = useContext(PlayerProfileContext);

  return <span className={className}>{secondaryHeader}</span>;
};
